import React from "react";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { WORD_WHEEL_DAILY_UNLOCK_LEVEL } from "../lib/constants";

/**
 * Branded daily-lock popup — mirrors Android DailyLockedModal.
 */
export default function DailyLockedModal({
    open,
    onClose,
    unlockLevel = WORD_WHEEL_DAILY_UNLOCK_LEVEL,
    colors,
}) {
    const surface = colors?.surface || "#f3fbf7";
    const text = colors?.text || "#064e3b";
    const muted = colors?.textMuted || "rgba(6, 78, 59, 0.55)";
    const primary = colors?.primary || "#0d9488";
    const primaryGlow = colors?.primaryGlow || "#0f766e";
    const surfaceLight = colors?.surfaceLight || "#d8f3e7";

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    bgcolor: surface,
                    border: `1.5px solid ${primary}`,
                    mx: 2,
                    p: 2.5,
                    textAlign: "center",
                    boxShadow: "0 12px 32px rgba(13, 148, 136, 0.28)",
                },
            }}
            slotProps={{
                backdrop: {
                    sx: { backgroundColor: "rgba(4, 24, 28, 0.72)" },
                },
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    mx: "auto",
                    mb: 2,
                    bgcolor: surfaceLight,
                    border: `2px solid ${primary}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <LockOutlinedIcon sx={{ color: primaryGlow, fontSize: 28 }} />
                <Box
                    sx={{
                        position: "absolute",
                        right: -2,
                        bottom: -2,
                        width: 26,
                        height: 26,
                        borderRadius: "50%",
                        bgcolor: primary,
                        border: "2px solid #fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <CalendarMonthOutlinedIcon sx={{ color: "#fff", fontSize: 12 }} />
                </Box>
            </Box>

            <Typography sx={{ fontWeight: 800, fontSize: 20, color: text, letterSpacing: -0.2 }}>
                Daily Puzzle locked
            </Typography>
            <Typography sx={{ mt: 1.25, fontSize: 15, lineHeight: 1.45, color: muted }}>
                Reach Season Journey level {unlockLevel} to unlock today&apos;s bonus puzzle.
            </Typography>

            <Box
                sx={{
                    mt: 2,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 1,
                    px: 1.75,
                    py: 1,
                    borderRadius: 999,
                    bgcolor: surfaceLight,
                    border: `1px solid ${primary}`,
                }}
            >
                <MapOutlinedIcon sx={{ fontSize: 16, color: primaryGlow }} />
                <Typography sx={{ fontWeight: 800, fontSize: 14, color: primaryGlow }}>
                    Level {unlockLevel}
                </Typography>
            </Box>

            <Button
                fullWidth
                variant="contained"
                onClick={onClose}
                sx={{
                    mt: 2.5,
                    minHeight: 48,
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 800,
                    fontSize: "1rem",
                    bgcolor: primary,
                    "&:hover": { bgcolor: colors?.accentDark || primaryGlow },
                }}
            >
                Keep playing
            </Button>
        </Dialog>
    );
}
